export default "__VITE_ASSET__aN9q2lvY__"